export function formatObjectDecimals(value, decimals) {
    const places = Math.max(0, Math.min(6, Number(decimals) || 0));
    return Number(value).toFixed(places);
}
